import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      background: '#fff',
      border: `1px solid ${theme.colors.gray[1]}`,
      padding: 4,
      borderRadius: 12,
      width: 254,
      boxShadow:
        '0px 0px 1px 0px #0000000A, 0px 2px 8px 0px #0000000A, 0px 10px 16px 0px #0000000A',
      [theme.fn.smallerThan('sm')]: {
        transform: 'translateX(-50%)',
      },
    },
    input: {
      input: {
        paddingLeft: 40,
      },
    },
    inputWrapper: { position: 'relative' },
    searchIcon: {
      position: 'absolute',
      top: 10,
      left: 16,
    },
    item: {
      padding: `${rem(8)} ${rem(12)}`,
      transition: 'background .2s ease',
      cursor: 'pointer',
      '&[data-is-current-loc="true"]': {
        position: 'relative',
        marginBottom: 16,
        '&:before': {
          position: 'absolute',
          top: `calc(100% + 8px)`,
          left: 0,
          right: 0,
          content: '""',
          borderBottom: `1px solid ${theme.colors.neutral[1]}`,
        },
      },
      '&[data-selected="true"]': {
        cursor: 'default',
      },
      '&[data-selected="true"],&:hover': {
        backgroundColor: theme.colors.gray[1],
        borderRadius: 8,
      },
    },
  }
})
